import { connect } from 'react-redux'

import { RouteTile } from '@bikemap/components'
import { showLoginModal } from '@bikemap/js/integrations/authentication'
import { addFavorite, removeFavorite } from './actions'
import { gettext } from '../../services'
import sessionData from '@bikemap/js/services/sessionData'
import { WEB_APP_URLS } from '@bikemap/js/settings'
import { getWebAppParams } from '../global/web-app-links'

const t = {
    LOGIN_TEXT: gettext('Sign up for free and add routes to your favorites'),
}

const mapStateToProps = ({ routes, users }, { routeId }) => {
    const route = routes[routeId]
    return {
        route,
        user: route.user ? users[route.user] : null,
        getRouteUrl: () => WEB_APP_URLS.WEB_APP_ROUTE_DETAILS_URL.replace(':id', route.id) + getWebAppParams(),
    }
}

const mapDispatchToProps = (dispatch, { routeId }) => ({
    onFavorite: status => {
        if (sessionData.getCurrentLoggedInState()) {
            dispatch(status ? addFavorite(routeId) : removeFavorite(routeId))
        } else {
            showLoginModal({
                header: null,
                title: t.LOGIN_TEXT,
            })
        }
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(RouteTile)
